<h2 mat-dialog-title>{{ dialogData.title }}</h2>

<mat-dialog-content>
  {{ dialogData.text }}
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close color="primary">Cancel</button>
  <button mat-button color="primary" (click)="confirm()">Yes</button>
</mat-dialog-actions>
